import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { BillingPayer } from 'src/models/employerDeedOrder/types';

export default autoGeneratedReducer<BillingPayer[]>([]);
